import "../SMSSolutions/SMSSolutions.css";
import {
  FaCheckCircle,
  FaWallet,
  FaGlobe,
  FaLaptop,
  FaPhoneAlt,
  FaHeartbeat,
  FaUniversity,
  FaShoppingCart,
  FaGraduationCap,
  FaBuilding,
  FaPlane,
} from "react-icons/fa";
import centerImage from "../../pages/IVRSolutions/assets/ss.png";
import flowVoiceImage from "./assets/flow-voice.png";
const VoiceSolutions = () => {
  return (
    <>
      <div className="services-bannerff">
        <div className="overlayff"></div>
        <div className="contentff">
          <div className="lineff"></div>
          <div>
            <h1>Voice Solutions</h1>
            <p>
              In nowadays’s fast-growing digital environment, groups want smart
              and reliable communication systems to stay in advance. <br /> Our
              advanced <b className="bold">voice solutions</b> are designed to
              deliver seamless connectivity, improve collaboration, <br />
              and enhance patron interaction.
            </p>
            <p>
              <span className="homeff">Home</span> → Service → Voice Solutions
            </p>
          </div>
        </div>
      </div>
      <section className="ivr-section">
        <div className="ivr-container">
          <section className="about-sectionvv">
            <div className="about-containervv">
              <div className="about-contentvv">
                <span className="about-tagvv">Voice Service</span>

                <h1>What is a Voice Service?</h1>

                <p className="about-descvv">
                  A voice carrier is a present-day conversation gadget that
                  allows voice calls over the internet rather than conventional
                  smartphone traces. This technology is typically known as a
                  <b className="bold"> voice over ip service</b>. Key Points:
                </p>
                <div className="about-featuresvv">
                  <div className="feature-rightvv">
                    <p>
                      <FaCheckCircle /> Uses the network protocol for voice
                      transmission.
                    </p>
                    <p>
                      <FaCheckCircle /> Eliminates the need for traditional
                      phone traces.
                    </p>
                    <p>
                      <FaCheckCircle /> Works via cloud-based systems. quickly.
                    </p>
                    <p>
                      <FaCheckCircle /> Accessible from a couple of devices.
                    </p>
                  </div>
                </div>
                <p>
                  With a VoIP cell phone provider, groups can cope with
                  conversation from anywhere, making sure flexibility and
                  performance in day-to-day operations.
                </p>
                <br />
              </div>
            </div>
            <section className="services-bb">
              <div className="container-bb">
                <h5 className="subheading-bb">Voice Service Flow</h5>
                <h2 className="heading-bb">Voice Service Flow </h2>

                <div style={{ marginTop: "24px" }}>
                  <img
                    src={flowVoiceImage}
                    alt="Voice service flow diagram"
                    style={{ width: "100%", maxWidth: "1100px", height: "auto", display: "block", margin: "0 auto" }}
                  />
                </div>
              </div>
            </section>
            <section className="why-section">
              <div className="why-left">
                <span className="tags">Needs</span>

                <h1>Why Your Business Needs a Voice Service </h1>
                <p>
                  Communication is the spine of each a success enterprise. A
                  dependable voice over IP carrier helps agencies improve both
                  internal and external conversations.
                </p>
              </div>
              <br />
              <div className="why-container">
                <div className="why-right">
                  <div className="card">
                    <h3>
                      <FaWallet className="why-icon" /> Cost Savings
                    </h3>
                    <p>
                      Reduce costly telecom bills with voip telephone carrier
                    </p>
                  </div>
                  <div className="card">
                    <h3>
                      <FaGlobe className="why-icon" /> Global Connectivity
                    </h3>
                    <p>
                      Connect with clients worldwide the usage of voice
                      solutions
                    </p>
                  </div>
                  <div className="card">
                    <h3>
                      <FaLaptop className="why-icon" /> Remote Work Friendly
                    </h3>
                    <p>Teams can paintings from anywhere</p>
                  </div>
                  <div className="card">
                    <h3>
                      <FaPhoneAlt className="why-icon" /> Better Call Quality
                    </h3>
                    <p>Clear and uninterrupted communication</p>
                  </div>
                </div>
              </div>
            </section>
            <section className="why-sectionz">
              <h2>Key Features of Our Voice Service</h2>

              <p className="why-descz">
                Our voice answers are constructed with cutting-edge generation
                to provide effective and green conversation equipment.
              </p>

              <div className="why-containerz">
                <div className="why-gridz">
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle />
                      HD Voice Quality with superior voice over ip service
                    </p>
                    <p>
                      <FaCheckCircle />
                      Cloud-Based System for clean get entry to through
                    </p>
                    <p>
                      <FaCheckCircle /> Call Forwarding & Routing
                    </p>
                  </div>
                  <div className="why-colz">
                    <p>
                      <FaCheckCircle /> Call Recording & Monitoring
                    </p>
                    <p>
                      <FaCheckCircle /> Analytics & Reporting Tools
                    </p>
                    <p>
                      <FaCheckCircle /> Secure Communication Network
                    </p>
                  </div>
                </div>
              </div>
            </section>
            <section className="industriesss">
              <h2>Industries We Serve</h2>
              <p>
                Our voice solutions are trusted across multiple industries for
                their reliability and performance.{" "}
              </p>
              <br />
              <div className="industries-containerss">
                <div className="industries-rightss">
                  <div className="cardss"><FaHeartbeat className="industry-icon" /> Healthcare</div>
                  <div className="cardss"><FaUniversity className="industry-icon" /> Banking & Finance</div>
                  <div className="cardss"><FaShoppingCart className="industry-icon" /> E-commerce</div>
                  <div className="cardss"><FaGraduationCap className="industry-icon" /> Education</div>
                  <div className="cardss"><FaBuilding className="industry-icon" /> Real Estate</div>
                  <div className="cardss"><FaPlane className="industry-icon" /> Travel & Hospitality</div>
                </div>
              </div>
            </section>
            <section className="whyss">
              <p className="subtitless">WHY CHOOSE US</p>
              <h2 className="titless">Why Choose Our Voice Service?</h2>
              <p>
                Choosing the right company can transform your commercial
                enterprise communication. Our voice solutions stand out due to
                their nice, reliability, and overall performance.
              </p>

              <div className="why-containerss">
                <div className="center-imagess">
                  <img src={centerImage} alt="transport" />
                </div>
                <div className="left-cardsss">
                  <div className="cardsss left-card card1">
                    <span> Affordable and scalable voice over IP service </span>
                  </div>
                  <div className="cardsss left-card card2">
                    <span>
                      {" "}
                      Easy-to-use <b>VoIP phone service </b>interface{" "}
                    </span>
                  </div>
                </div>
                <div className="right-cards">
                  <div className="cardsss left-card card3">
                    <span>24/7 customer support </span>
                  </div>
                  <div className="cardsss right-card card4">
                    <span>High uptime and reliability</span>
                  </div>
                </div>
              </div>
            </section>
            <br />
            <br />
          </section>
        </div>
      </section>
    </>
  );
};

export default VoiceSolutions;
